import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function MissionSection() {
  const { ref: leftRef, isVisible: leftVisible } = useScrollAnimation({ threshold: 0.2 });
  const { ref: rightRef, isVisible: rightVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="py-0 overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[600px]">
        {/* Left - Mission */}
        <div
          ref={leftRef}
          className={`scroll-hidden-left ${leftVisible ? 'scroll-visible' : ''} flex-1 lg:w-[65%] bg-gradient-hero relative flex items-center px-6 sm:px-12 lg:px-20 py-16 sm:py-20`}
        >
          {/* Noise texture overlay */}
          <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 200 200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'n\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23n)\'/%3E%3C/svg%3E")' }} />

          <div className="relative z-10 max-w-2xl">
            {/* Oversized quote mark */}
            <div className="font-heading text-9xl leading-none text-brand-yellow/20 select-none mb-4">&ldquo;</div>

            <span className="font-body text-brand-yellow text-xs uppercase tracking-widest font-semibold mb-4 block">
              Our Mission
            </span>
            <div className="w-14 h-0.5 bg-brand-yellow mb-8" />

            <p className="font-heading text-white text-xl sm:text-2xl lg:text-3xl font-light leading-relaxed italic mb-8">
              Creative Institute LLC is a premier music and creative development center dedicated to cultivating talent, confidence, and purpose through high-level instruction and mentorship.
            </p>

            <p className="font-body text-white/50 text-sm leading-relaxed mb-4">
              We specialize in piano, vocals, drums, and creative coaching, while also offering professional production and creative services.
            </p>

            <p className="font-body text-white/50 text-sm leading-relaxed">
              At the heart of our mission is a deep commitment to neurodivergent creatives — because creativity is not one-size-fits-all. We intentionally create environments where individuals with autism, ADHD, and diverse learning styles can thrive, express themselves freely, and develop at their own pace.
            </p>
          </div>
        </div>

        {/* Right - Vision */}
        <div
          ref={rightRef}
          className={`scroll-hidden-right ${rightVisible ? 'scroll-visible' : ''} flex-1 lg:w-[35%] bg-brand-yellow-soft flex flex-col items-center justify-center px-10 py-20 text-center`}
        >
          {/* Badge */}
          <div className="w-36 h-36 rounded-full border-4 border-brand-purple flex flex-col items-center justify-center mb-10 pulse-border">
            <span className="font-body text-brand-purple text-xs uppercase tracking-widest font-bold">Where Every</span>
            <span className="font-heading text-brand-blue-dark text-lg font-black leading-tight">Creative<br />Mind</span>
            <span className="font-body text-brand-purple text-xs uppercase tracking-widest font-bold">Matters</span>
          </div>

          <span className="font-body text-brand-yellow-dark text-xs uppercase tracking-widest font-semibold mb-3">
            Our Vision
          </span>

          <p className="font-body text-brand-blue-dark/70 text-sm leading-relaxed max-w-xs">
            To establish Creative Institute as a premier creative hub that transforms lives through the power of the arts — where individuals of all backgrounds and abilities are empowered to discover their voice and walk confidently in their purpose.
          </p>

          <div className="mt-8 flex items-center gap-3">
            <div className="w-8 h-0.5 bg-brand-purple" />
            <span className="font-body text-brand-purple text-xs uppercase tracking-widest">Jaquan Little, Founder</span>
            <div className="w-8 h-0.5 bg-brand-purple" />
          </div>
        </div>
      </div>
    </section>
  );
}
